import { useState } from 'react';
import FreeTrialModal from './FreeTrialModal';
import ConsultationModal from './ConsultationModal';

export default function Hero() {
  const [showTrialModal, setShowTrialModal] = useState(false);
  const [showConsultModal, setShowConsultModal] = useState(false);

  return (
    <>
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        {/* ナビゲーションバー */}
        <nav className="absolute top-0 left-0 right-0 z-30 px-6 py-4 flex items-center justify-end">
          <a 
            href="tel:0829-78-1638" 
            className="text-white font-bold text-sm md:text-4xl bg-white/20 backdrop-blur-sm px-4 py-1.5 md:px-8 md:py-4 rounded-full hover:bg-white/30 transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line mr-2"></i>
            0829-78-1638
          </a>
        </nav>

        {/* 背景画像 */}
        <div className="absolute inset-0 bg-[#1A2B4A]">
          <img
            src="https://static.readdy.ai/image/58c223b9eef17a4b88bac47f4e33252a/3d85a50a8488b2baadd8b877a91925b1.jpeg"
            alt="学習塾NICK 廿日市市大野"
            className="w-full h-full object-top object-contain md:object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>

        {/* メインコンテンツ */}
        <div className="relative z-10 flex-1 flex flex-col justify-end px-6 md:px-12 pt-24 pb-12 md:justify-start md:pb-0 md:pt-24">
          <div className="max-w-lg md:max-w-3xl lg:max-w-5xl mx-auto w-full">
            {/* キャッチコピー */}
            <h1 
              className="text-[28px] md:text-[56px] lg:text-[64px] leading-[1.3] font-black mb-2 md:mb-5 text-left"
              style={{
                color: '#FFFFFF',
              }}
            >
              ここが志望校への<br />
              最短ルート。<br />
            </h1>
            
            <div className="mt-10 md:mt-6 mb-6 md:mb-8">
              <div className="mb-4">
                <p 
                  className="text-[15px] md:text-5xl font-black tracking-widest"
                  style={{
                    color: '#F5E6C8',
                    textShadow: '0 2px 12px rgba(0,0,0,0.7)',
                    letterSpacing: '0.15em',
                  }}
                >
                  <br className="hidden md:block" />
                  廿日市市大野の<span style={{ color: '#FFD060' }}>学習塾NICK</span>
                </p>
              </div>
              <div className="bg-white md:bg-white/15 md:backdrop-blur-sm border-l-4 border-[#FFD060] px-5 py-4 rounded-r-lg">
                <p className="text-xs md:text-xl leading-relaxed font-bold text-[#1A2B4A]">
                  個別指導と集団指導を合わせた<br />
                  <span className="text-[#FF6B35] text-sm md:text-2xl font-black">ハイブリッド型の指導</span>で、<br className="md:hidden" />
                  <span className="text-[#FF6B35] text-sm md:text-2xl font-black">内申点対策</span>と<span className="text-[#FF6B35] text-sm md:text-2xl font-black">高校受験</span><br />
                  を完全サポート
                </p>
              </div>
            </div>

            {/* CTAボタン群 */}
            <div className="space-y-4 md:space-y-0 md:flex md:gap-4 mt-8 md:mt-10">
              <button
                onClick={() => setShowTrialModal(true)}
                className="w-full md:w-auto md:flex-1 h-14 md:h-16 bg-[#FF6B35] text-white rounded-full font-bold text-base md:text-lg shadow-2xl hover:bg-[#FF6B35]/90 transition-all flex items-center justify-between px-6 md:px-8 whitespace-nowrap"
              >
                <span>無料体験を申し込む</span>
                <span className="w-8 h-8 md:w-10 md:h-10 bg-white rounded-full flex items-center justify-center ml-3 md:ml-4">
                  <i className="ri-arrow-right-line text-[#FF6B35] text-lg md:text-xl"></i>
                </span>
              </button>

              <button
                onClick={() => setShowConsultModal(true)}
                className="w-full md:w-auto md:flex-1 h-14 md:h-16 bg-white text-[#1A2B4A] rounded-full font-bold text-base md:text-lg border-2 border-white hover:bg-white/90 transition-all whitespace-nowrap"
              >
                受験相談を予約する
              </button>

              <a
                href="https://lin.ee/Od9tigSF"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full md:w-auto md:flex-1 h-14 md:h-16 bg-[#06C755] text-white rounded-full font-bold text-base md:text-lg shadow-lg hover:bg-[#06C755]/90 transition-all flex items-center justify-center gap-2 whitespace-nowrap"
              >
                <i className="ri-line-fill text-xl md:text-2xl"></i>
                <span>LINEで質問する</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      {showTrialModal && <FreeTrialModal onClose={() => setShowTrialModal(false)} />}
      {showConsultModal && <ConsultationModal onClose={() => setShowConsultModal(false)} />}
    </>
  );
}
